export default "__VITE_ASSET__CSm_cyfc__"